import { render, staticRenderFns } from "./SupportPublic.vue?vue&type=template&id=4e4180be&"
import script from "./SupportPublic.vue?vue&type=script&lang=js&"
export * from "./SupportPublic.vue?vue&type=script&lang=js&"
import style0 from "./SupportPublic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports